import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 1.2rem 0.8rem;

  border-bottom: 0.1rem solid ${pickColor('borderColorLight')};
`;

export { Container };
